export const collapseExpand = () => {
    const levels = document.querySelectorAll(".article-sidebar li");

    if (levels) {
        for (let level of levels) {
            // If this is a toc tree level (1,2,3,4...) add chevron arrow
            if (level.classList[0].includes("toctree-l")) {
                // Create the arrow button
                const arrowButton = document.createElement("button");
                arrowButton.classList.add("button-sidebar-expand");
                arrowButton.style.border = "none";

                // Add the active state if the level is current
                if (level.classList.contains("current")) {
                    arrowButton.classList.add("active");
                    if (arrowButton.previousElementSibling) {
                        arrowButton.previousElementSibling.style.display = "block";
                    }
                }
                // Add the SVG icon inside
                arrowButton.innerHTML =
                    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';

                // If this level has a children ul, append it
                if (level.querySelector("ul")) {
                    level.appendChild(arrowButton);
                }

                // Click event for the arrow buttons. Controls the open state of the children ul and rotation of the icon
                arrowButton.addEventListener("click", function(e) {
                    e.preventDefault;
                    if (arrowButton.previousElementSibling.tagName === "UL") {
                        // If open
                        if (!arrowButton.classList.contains("active")) {
                            arrowButton.classList.add("active");
                            arrowButton.previousElementSibling.style.display = "block";
                        } else {
                            arrowButton.classList.remove("active");
                            arrowButton.previousElementSibling.style.display = "none";
                        }
                    }
                });
            }
        }
    }
};
